$( document ).ready(function() {
  console.log('load cartDear');
/**
 * Copy meta data to notes for DEAR
 */
  if($('#cart-form').length) {
    console.log('Found note field');
    copyOrdersToNotes();
    
    $("#shopify-section-static-cart > form > section > div > div > div.cart-checkout > button").on('click', function () {
      copyOrdersToNotes();
    });

    $('#shopify-section-static-cart > form > header > div.cart-title-right > button').on('click', function () {
      copyOrdersToNotes();
    });
    
    function copyOrdersToNotes() {
      
      let ordersToNotes = '|| ';
    
        $('.cart-item--content').each(function(index) {
          let matches = $( this ).text().matchAll(/[\$\w].*/gm)
          let titleText = '';
          for (match of matches) {
              console.log(match[0]);
              titleText += match[0].replace(/\s\s/gm, '') + ' | ';
          }
          ordersToNotes += titleText.replace(/\//gm, ' > ') + " \n\n|| ";
          console.log('titleText', titleText);
        });

      // alert(ordersToNotes);
      // fill notes field
      console.log( "ordersToNotes", ordersToNotes.trim().slice(0, -2));
      $('#cart-note').val(ordersToNotes.trim().slice(0, -2));
    }
  }

/*
  // hack custom calc - Liner metres calculator
  setTimeout(function() {
    console.log('try and find custom calc')
    if($('input[name="properties[Length (Metres)]"]').length && $('select[name="properties[Width]"]').length) {
      // set the inital csku ele up
      $('#custom-additional-comments').after('<input type="hidden" id="custom-sku" name="properties[csku]" value="'+$('.product-sku').text().replace('SKU', '').trim()+'"/>');
      // hide qty and varraient drop down
      $('#data-variant-option-0').hide();
      $('.form-field-select-wrapper').hide();

      // catch drop down change value
      $('select[name="properties[Width]"]').on('change', function() {
        $('#data-variant-option-0 option')[$('select[name="properties[Width]"]')[0].selectedIndex].selected = true;
        document.querySelector('#data-variant-option-0').dispatchEvent(new Event('change'));
        // update custom csku field
        console.log($('.product-sku').text().replace('SKU', '').trim())
        $('#custom-sku').val($('.product-sku').text().replace('SKU', '').trim()); 
      })
    }
  }, 3000);

  */
}); // end dom